import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
// styles
import './App.css'

// pages
import Dashboard from './Pages/Dashboard/Dashboard';
import Create from './Pages/Create/Create';
import Project from './Pages/Project/Project';
import Signup from './Pages/Signup/Signup';
import Login from './Pages/Login/Login';
import Navbar from './components/navbar/Navbar';

// components
import OnlineUsers from './components/online_users/OnlineUsers';
import Sidebar from './components/sidebar/Sidebar';

// hooks
import { useAuthContext } from './Hooks/useAuthContext'


function App() {
  const { user, authIsReady } = useAuthContext()
  return (
    <div className="App">
      { authIsReady && (
        <BrowserRouter>
          {user && <Sidebar />}
          <div className="container">
          <Navbar />
            <Switch>

              {/* Dashboard */}
              <Route path="/" exact>
                {user && <Dashboard />}
                {!user && <Redirect to='/login' />}
              </Route>

              {/* Login */}
              <Route path="/login" >
                {!user && <Login />}
                {user && <Redirect to='/' />}
              </Route>

              {/* Signup */}
              <Route path="/signup" >
                {!user && <Signup />}
                {user && <Redirect to='/' />}
              </Route>

              {/* Project */}
              <Route path="/projects/:id" exact>
                {user && <Project />}
                {!user && <Redirect to='/login' />}
              </Route>

              {/* Create */}
              <Route path="/create" >
                {user && <Create />}
                {!user && <Redirect to='/login' />}
              </Route>

            </Switch>
          </div>
          {user && <OnlineUsers />}
        </BrowserRouter>
      )}
    </div>
  );
}

export default App
